<nav>
  @for (item of this.getMenuItems(); track trackById(item)) {
  <div [attr.id]="'nav_' + getIdAsSelector(item.id)" [ngClass]="item.path == selectedId ? 'selected' : ''">
    <a href="#" [routerLink]="item.path">
      <div>{{ item.title }}</div>
    </a>
  </div>
  }
</nav>